import angular from 'angular'
import './default_bounty_shinies.service'
import './edit/edit.controller'

angular
  .module('admin.default_bounty_shinies', [
    'admin.default_bounty_shinies.service',
    'admin.default_bounty_shinies.edit',
  ])
  .controller('DefaultBountyShiniesCtrl', DefaultBountyShiniesCtrl)

/** @ngInject */
function DefaultBountyShiniesCtrl($state, $timeout, DefaultBountyShiniesService) {
  var vm = this
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'ts-desc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-asc'
  vm.sortReverse2 = false
  vm.sortType3 = 'ts-end-desc'
  vm.sortReverse3 = false

  function reloadPaginationDraft() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalItems2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function reloadPaginationArchived() {
    vm.totalItems3 = 0
    vm.oldPage3 = 0
    vm.currentPage3 = 25
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()
  reloadPaginationArchived()
  loadPublished(1)
  loadUnpublished(1)
  loadArchived(1)

  var tab = localStorage.getItem('default_bounty_shinies')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#archived').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#archived').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    } else if (tab === 'expired') {
      $('#draft').removeClass('active')
      $('#published').removeClass('active')
      $('#expired').addClass('active')
      $('#expiredtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#expired').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('default_bounty_shinies', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#expired').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('default_bounty_shinies', 'published')
  }

  vm.tabExpired = function () {
    $('#draft').removeClass('active')
    $('#published').removeClass('active')
    $('#expired').addClass('active')
    localStorage.setItem('default_bounty_shinies', 'expired')
  }

  var oldSortType, oldSortType2, oldSortType3
  function loadUnpublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    DefaultBountyShiniesService.listUnpublish(vm.oldPage, 25, vm.sortType).then(function (result) {
      var rewards = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p'] !== undefined) {
          rewards[i].isPub = true
        } else {
          rewards[i].isPub = false
        }
        if (pageNumber === 1 && i === 0) {
          rewards[i].firstRow = true
        }

        if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
          rewards[i].lastRow = true
        }
        if (rewards[i]['k-render'] === 0) {
          rewards[i].typeRender = 'Basic'
        } else if (rewards[i]['k-render'] === 1) {
          rewards[i].typeRender = 'Red'
        } else if (rewards[i]['k-render'] === 2) {
          rewards[i].typeRender = 'Gold'
        } else if (rewards[i]['k-render'] === 3) {
          rewards[i].typeRender = 'Purple'
        } else if (rewards[i]['k-render'] === 4) {
          rewards[i].typeRender = 'Silver Metallic'
        }
      }
      vm.sortType = oldSortType
      vm.itemsDraft = rewards
    })
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    DefaultBountyShiniesService.listPublish(vm.oldPage2, 25, vm.sortType2).then(function (result) {
      var rewards = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p']) {
          rewards[i].isPub = true
        } else {
          rewards[i].isPub = false
        }
        if (pageNumber === 1 && i === 0) {
          rewards[i].firstRow = true
        }

        if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
          rewards[i].lastRow = true
        }
        if (rewards[i]['k-render'] === 0) {
          rewards[i].typeRender = 'Basic'
        } else if (rewards[i]['k-render'] === 1) {
          rewards[i].typeRender = 'Red'
        } else if (rewards[i]['k-render'] === 2) {
          rewards[i].typeRender = 'Gold'
        } else if (rewards[i]['k-render'] === 3) {
          rewards[i].typeRender = 'Purple'
        } else if (rewards[i]['k-render'] === 4) {
          rewards[i].typeRender = 'Silver Metallic'
        }
      }
      vm.sortType2 = oldSortType2
      vm.itemsPublish = rewards
    })
  }

  function loadArchived(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first) {
      vm.currentPage3 = pageNumber * 25
      vm.oldPage3 = vm.currentPage2 - 25
    } else {
      vm.first3 = false
    }

    oldSortType3 = angular.copy(vm.sortType3)
    DefaultBountyShiniesService.listArchived(vm.oldPage3, 25, vm.sortType3).then(function (result) {
      var rewards = result.results
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < rewards.length; i++) {
        if (rewards[i]['ts-p']) {
          rewards[i].isPub = true
        } else {
          rewards[i].isPub = false
        }
        if (pageNumber === 1 && i === 0) {
          rewards[i].firstRow = true
        }

        if (rewards.length - 1 === i && rewards.length < vm.currentPage) {
          rewards[i].lastRow = true
        }
        if (rewards[i]['k-render'] === 0) {
          rewards[i].typeRender = 'Basic'
        } else if (rewards[i]['k-render'] === 1) {
          rewards[i].typeRender = 'Red'
        } else if (rewards[i]['k-render'] === 2) {
          rewards[i].typeRender = 'Gold'
        } else if (rewards[i]['k-render'] === 3) {
          rewards[i].typeRender = 'Purple'
        } else if (rewards[i]['k-render'] === 4) {
          rewards[i].typeRender = 'Silver Metallic'
        }
      }
      vm.sortType3 = oldSortType3
      vm.itemsArchived = rewards
    })
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadUnpublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged2 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChanged3 = function (newPage) {
    vm.sortType3 = oldSortType3
    loadArchived(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = function () {
    $state.go('admin.default_bounty_shinies.edit', { id: 0 })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DefaultBountyShiniesService.remove(item.id).then(
            function () {
              $state.reload()
            },
            function () {
              $timeout(function () {
                swal("You can't delete because has things associated with it", '', 'error')
              }, 750)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.publish = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DefaultBountyShiniesService.publish(item.id).then(function () {
            $state.reload()
          })
        }
      },
    )
  }

  vm.unpublish = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DefaultBountyShiniesService.unpublish(item.id).then(function () {
            $state.reload()
          })
        }
      },
    )
  }

  vm.expire = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          DefaultBountyShiniesService.update(item.id, {
            'ts-end': parseInt(new Date(new Date().setSeconds(0)).getTime() * 1000),
          }).then(
            function () {
              $state.reload()
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 200)
            },
          )
        }
      },
    )
  }

  vm.clone = function (item) {
    const cl = angular.copy(item)
    delete cl.id
    delete cl.ts
    delete cl['ts-end']

    DefaultBountyShiniesService.create(cl).then(
      function () {
        $state.reload()
      },
      function (err) {
        $timeout(function () {
          swal(err.error.message, '', 'error')
        }, 200)
      },
    )
  }

  vm.back = function () {
    loadUnpublished(1)
    loadPublished(1)
    loadArchived(1)
  }

  vm.arrowUp = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n - 1
    ChannelHeroBannerService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'ts-desc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-end-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.arrowDown = function (item) {
    if (item.edit) {
      return
    }
    var copy = angular.copy(item)
    copy.n = copy.n + 1
    ChannelHeroBannerService.update(item.id, {
      n: copy.n,
    }).then(function () {
      vm.sortType = 'ts-desc'
      vm.sortReverse = false
      vm.sortType2 = 'n-asc'
      vm.sortReverse2 = false
      vm.sortType3 = 'ts-end-desc'
      vm.sortReverse3 = false
      loadUnpublished(vm.pagination.current)
      loadPublished(vm.pagination2.current)
      loadArchived(vm.pagination3.current)
    })
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadUnpublished(vm.pagination.current)
    } else if (isTab === 2) {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    } else if (isTab === 3) {
      vm.sortReverse3 = !vm.sortReverse3
      if (vm.sortReverse3) {
        vm.sortType3 = type + '-asc'
      } else {
        vm.sortType3 = type + '-desc'
      }
      loadArchived(vm.pagination3.current)
    }
  }
}
